import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';

export enum UpdateEmailActionType {
    UPDATE_EMAIL_REQUEST = 'USERS_UPDATE_EMAIL_REQUEST',
    UPDATE_EMAIL_SUCCESS = 'USERS_UPDATE_EMAIL_SUCCESS',
    UPDATE_EMAIL_FAILURE = 'USERS_UPDATE_EMAIL_FAILURE',
}

export type UpdateEmailAction =
    | { type: UpdateEmailActionType.UPDATE_EMAIL_SUCCESS; payload: { email: string } }
    | { type: UpdateEmailActionType.UPDATE_EMAIL_REQUEST; payload: {} }
    | {
          type: UpdateEmailActionType.UPDATE_EMAIL_FAILURE;
          payload: { errorResolution: ErrorResolution };
      };
